import Vue from 'vue';
import { Common } from '@om-retail/vue-common';

const stateApp = {
    outrights: {},
    outrightsOfferLoading: false,
    outrightError: null,
    selectedOutrightId: null,
    selectedOutrightIds: [],
    subscribedOutrights: [],
    subscribedTicketOutrights: [],
    acceptedSportEventStatuses: 'active,block',
    connectedOutrights: null,
    outrightTree: null,
    allTreeItems: [],
    outrightsTreeMapping: null,
    selectedOutrightsItems: [],
    filteredOutrights: {},
};

// getters
const getters = {
    getOutrights: (state) => state.outrights,
    outrightsOfferLoading: (state) => state.outrightsOfferLoading,
    outrightError: (state) => state.outrightError,
    selectedOutrightId: (state) => state.selectedOutrightId,
    selectedOutrightIds: (state) => state.selectedOutrightIds,
    connectedOutrights: (state) => state.connectedOutrights,
    outrightTree: (state) => state.outrightTree,
    allTreeItems: (state) => state.allTreeItems,
    outrightsTreeMapping: (state) => state.outrightsTreeMapping,
    selectedOutrightsItems: (state) => state.selectedOutrightsItems,
    filteredOutrights: (state) => state.filteredOutrights,
};

let changedOutrights = [];
let changedOutrightsSettingInterval = null;
let vertical;

// actions
const actions = {
    async initOutrightsOffer(context, verticalIn)
    {
        vertical = verticalIn;
        await context.dispatch('fetchOutrights');

        context.rootState.offer.offerHandling.setOfferReloadFunctions({
            name: 'fetchOutrights',
            func: async () =>
            {
                context.dispatch('fetchOutrights');
            },
        });

        context.rootState.offer.offerHandling.subscribe(
            `${context.rootState.globals.globals.langCode}_outright`,
            async (outright) =>
            {
                changedOutrights.push(outright);
            },
        );

        let isRunning = false;

        changedOutrightsSettingInterval = setInterval(() =>
        {
            if (changedOutrights.length === 0
            || isRunning
            || context.rootState.offer.offerLoading)
            {
                return;
            }

            isRunning = true;
            for (const outright of changedOutrights)
            {
                let selectedMatchId = null;

                if (vertical === 'sport')
                {
                    // connected with match
                    for (const treeItem of outright.tree)
                    {
                        if (treeItem.connectionType === 'match')
                        {
                            selectedMatchId = outright.outrightsOfferId;
                            break;
                        }
                    }

                    // connected with sport/category/tournament
                    if (selectedMatchId == null && context.rootState.sport.selectedMatches.length)
                    {
                        for (const selectedMatch of context.rootState.sport.selectedMatches)
                        {
                            if (selectedMatch.id === outright.outrightsOfferId)
                            {
                                selectedMatchId = outright.outrightsOfferId;
                                break;
                            }
                        }
                    }
                }

                const outrigtInState = context.state.outrights[outright.outrightsOfferId];

                if (outright.status === 'active' || outright.status === 'block')
                {
                    for (const market of outright.markets)
                    {
                        market.show = false;

                        for (const outcome of market.outcomes)
                        {
                            if (outcome.status === 'active' || outcome.status === 'block')
                            {
                                market.show = true;
                                if (outrigtInState !== undefined
                                    && outrigtInState.outrightsOfferId === outright.outrightsOfferId
                                    && outrigtInState.shouldRemove)
                                {
                                    outright.shouldRemove = false;
                                }
                                break;
                            }
                        }
                        if (market.show)
                        {
                            context.commit('setOutright', outright);

                            break;
                        }
                        else if (!market.show && outright.markets.indexOf(market) === outright.markets.length - 1)
                        {
                            if (context.state.selectedOutrightIds.includes(outright.outrightsOfferId)
                            || (vertical === 'sport'
                            && selectedMatchId === outright.outrightsOfferId
                            && (outrigtInState !== undefined && outrigtInState.connectedMatchOpen)))
                            {
                                outright.shouldRemove = true;
                                outright.markets[0].show = true;

                                context.commit('setOutright', outright);
                            }
                            else
                            {
                                context.dispatch('removeOutright', outright);
                            }
                        }
                    }

                    if (!outrigtInState && vertical === 'outrights')
                    {
                        context.dispatch('makeTree');
                    }
                }
                else if (context.state.selectedOutrightIds.includes(outright.outrightsOfferId)
                || (vertical === 'sport'
                && selectedMatchId === outright.outrightsOfferId
                && (outrigtInState !== undefined && outrigtInState.connectedMatchOpen)))
                {
                    outright.shouldRemove = true;
                    outright.markets[0].show = true;

                    context.commit('setOutright', outright);
                }
                else
                {
                    context.dispatch('removeOutright', outright);
                }
            }
            changedOutrights = [];
            isRunning = false;
        }, 100);
    },
    makeTree(context)
    {
        const outrightsTreeMapping = {};
        const allTreeItems = [];
        const outrightsIn = context.state.outrights;

        // set tree items
        for (const id in outrightsIn)
        {
            if (outrightsIn[id] != null)
            {
                const outright = outrightsIn[id];

                const treeItem = outright.tree[0].treeItemId;
                if (!outrightsTreeMapping[treeItem])
                {
                    outrightsTreeMapping[treeItem] = { outrights: [] };
                }
                outrightsTreeMapping[treeItem].outrights.push(outright);

                for (const item of outright.tree)
                {
                    if (allTreeItems.some((singleTreeItem) => singleTreeItem.name === item.name))
                    {
                        continue;
                    }
                    else
                    {
                        allTreeItems.push({ id: item.treeItemId, name: item.name });
                    }
                }
            }
        }
        context.commit('setOutrightsTreeMapping', outrightsTreeMapping);
        context.commit('setAllTreeItems', allTreeItems);

        context.dispatch('setOutrightsOfferLoading', false);
        context.dispatch('setFilteredOutrights', context.state.outrights);

        // make tree
        const treeItems = {};
        // eslint-disable-next-line guard-for-in
        for (const outrightId in outrightsIn)
        {
            const outright = outrightsIn[outrightId];

            outright.tree = outright.tree.reverse();

            for (const treeItem of outright.tree)
            {
                if (!treeItems[treeItem.treeItemId])
                {
                    treeItem.children = [];
                    treeItem.opened = false;
                    treeItems[treeItem.treeItemId] = treeItem;
                }
            }
            outright.tree = outright.tree.reverse();
        }
        const treeItemsCp = JSON.parse(JSON.stringify(treeItems));
        const treeItemsArr = Object.values(treeItemsCp);

        const root = [];
        for (const treeItem of treeItemsArr)
        {
            if (context.state.outrightTree == null)
            {
                treeItem.opened = context.state.selectedOutrightsItems.includes(String(treeItem.treeItemId));
            }

            if (treeItem.parentId == null)
            {
                root.push(treeItem);
            }
            else
            {
                treeItemsCp[treeItem.parentId].children.push(treeItem);
            }

            // preserve old opened statuses
            if (context.state.outrightTree != null)
            {
                for (const oldTreeItem of context.state.outrightTree)
                {
                    if (oldTreeItem.treeItemId === treeItem.treeItemId)
                    {
                        treeItem.opened = oldTreeItem.opened;
                        break;
                    }
                    else
                    {
                        for (const child of oldTreeItem.children)
                        {
                            if (child.treeItemId === treeItem.treeItemId)
                            {
                                treeItem.opened = child.opened;
                                break;
                            }
                            else
                            {
                                for (const grandchild of child.children)
                                {
                                    if (grandchild.treeItemId === treeItem.treeItemId)
                                    {
                                        treeItem.opened = grandchild.opened;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        context.commit('setOutrightTree', root);
    },
    updateTreeItem(context, treeItemId)
    {
        const tree = context.state.outrightTree;

        for (const treeItem of tree)
        {
            if (treeItem.treeItemId === treeItemId)
            {
                treeItem.opened = !treeItem.opened;
                break;
            }
            else
            {
                for (const childTreeItem of treeItem.children)
                {
                    if (childTreeItem.treeItemId === treeItemId)
                    {
                        childTreeItem.opened = !childTreeItem.opened;
                        break;
                    }
                }
            }
        }

        context.commit('setOutrightTree', tree);
    },
    setFilteredOutrights(context, outrights)
    {
        const { selectedOutrightsItems } = context.state;
        if (!outrights)
        {
            context.commit('setFilteredOutrights', {});
        }
        let filterOutrights = {};

        if (!selectedOutrightsItems.length)
        {
            filterOutrights = outrights;
        }
        else
        {
            const targetTreeItemId = selectedOutrightsItems[selectedOutrightsItems.length - 1];
            // eslint-disable-next-line guard-for-in
            for (const id in outrights)
            {
                const outright = outrights[id];

                for (const treeItem of outright.tree)
                {
                    if (String(treeItem.treeItemId) === targetTreeItemId
                        && !filterOutrights[targetTreeItemId])
                    {
                        filterOutrights[outright.outrightsOfferId] = outright;
                        break;
                    }
                }
            }
        }

        const groupedOutrights = {};
        for (const id in filterOutrights)
        {
            if (filterOutrights[id].status === 'active' || filterOutrights[id].status === 'block')
            {
                const outright = filterOutrights[id];
                const treeItemName = outright.tree[outright.tree.length - 1].name;

                if (groupedOutrights[treeItemName] == null)
                {
                    groupedOutrights[treeItemName] = {
                        itemId: outright.tree[0].treeItemId,
                        name: treeItemName,
                        outrights: [],
                    };
                }

                groupedOutrights[treeItemName].outrights.push(outright);
            }
        }

        const filteredOutrights = Object.values(groupedOutrights);
        context.commit('setFilteredOutrights', filteredOutrights);
    },
    setOutright(context, outright)
    {
        context.commit('setOutright', outright);
    },
    setSelectedOutrightsItems(context, data)
    {
        context.commit('setSelectedOutrightsItems', data);
    },
    setConnectedOutrights(context, items)
    {
        context.commit('setConnectedOutrights', items);
    },
    async fetchOutrights(context)
    {
        let params;

        if (context.rootState.offer.startDate != null && context.rootState.offer.endDate != null)
        {
            params = {
                startDate: context.rootState.offer.startDate.format('YYYY-MM-DD HH:mm:ss'),
                endDate: context.rootState.offer.endDate.format('YYYY-MM-DD HH:mm:ss'),
                status: context.state.acceptedSportEventStatuses,
            };
        }
        else
        {
            params = {
                status: context.state.acceptedSportEventStatuses,
            };
        }

        context.dispatch('setOutrightsOfferLoading', true);

        let res;

        try
        {
            res = await context.rootState.offer.offerHandling.callOffer(
                `/${context.rootState.globals.globals.langCode}/outrights/getOutrightsOffer`,
                params,
            );
        }
        catch (error)
        {
            context.dispatch('setOutrightsOfferLoading', false);
            context.commit('setOutrightError', 'NOOFFERAVAILABLE');
            if (error.timeout)
            {
                context.commit('setEventDetailsLoadingError', {
                    error: true,
                    callback()
                    {
                        context.dispatch('fetchOutrights');
                    },
                });
            }
        }

        for (const outright of res.data)
        {
            for (const market of outright.markets)
            {
                market.show = false;

                for (const outcome of market.outcomes)
                {
                    if (outcome.status === 'active' || outcome.status === 'block')
                    {
                        market.show = true;
                        break;
                    }
                }
                if (market.show)
                {
                    context.commit('setOutright', outright);
                    break;
                }
            }
        }
        if (context.rootGetters.betslipItems)
        {
            for (const item of context.rootGetters.betslipItems)
            {
                if (item.type === 'outrights')
                {
                    context.dispatch('subscribeToTicketOutright', item.matchId);
                }
            }
        }
        context.dispatch('setOutrightsOfferLoading', false);
        context.dispatch('toggleOutrightsTicketUpdates');
    },
    selectOutright(context, params)
    {
        // check where push is false
        const { outrightId, eventType, push } = params;

        if (context.state.selectedOutrightId !== outrightId)
        {
            context.commit('setSelectedOutrightId', outrightId);
        }
        if (!context.state.selectedOutrightIds.includes(outrightId) && push)
        {
            if (outrightId === null)
            {
                return;
            }

            context.commit('setSelectedOutrightIds', [...context.state.selectedOutrightIds, outrightId]);
        }

        if (eventType !== 'outrights')
        {
            if (outrightId == null)
            {
                context.dispatch('selectMatch', null);
                return;
            }
            const outright = { id: outrightId, type: 'outright' };

            if (context.rootState.sport.selectedMatch !== outright)
            {
                context.dispatch('selectMatch', outright);
            }
        }
    },
    removeSelectedOutright(context, outrightId)
    {
        const outright = context.state.outrights[outrightId];

        if (vertical === 'sport' && outright.shouldRemove)
        {
            // context.dispatch('removeOutright', outright);
            context.commit('setConnectedOutrights');

            return;
        }

        if ((context.state.selectedOutrightIds.length === 1))
        {
            context.commit('setSelectedOutrightIds', []);
        }
        else
        {
            const outrightIds = context.state.selectedOutrightIds.filter((id) => id !== outrightId);
            context.commit('setSelectedOutrightIds', outrightIds);
        }

        if (!context.state.selectedOutrightIds.includes(outrightId))
        {
            if (context.state.selectedOutrightIds.length)
            {
                context.commit('setSelectedOutrightId', context.state.selectedOutrightIds[0]);
            }
            else
            {
                context.commit('setSelectedOutrightId', null);
            }
        }
        // closing tab with no active odds/outright status
        if (outright.shouldRemove)
        {
            context.dispatch('removeOutright', outright);
        }
    },
    selectOutrightOutcome(context, param)
    {
        const {
            outright,
            market,
            outcome,
        } = param;

        if (outcome.value === '-' || outcome.status !== 'active' || outright.status !== 'active')
        {
            return;
        }

        // TODO remove this temp with library change
        outright.utcEndDate = outright.endDate;
        market.specHash = market.lineHash;

        const outcomeName = Common.formatModifierName(
            outcome.name,
            null,
            market.specifiers,
            this.state.globals.globals.langCode,
        );

        const marketName = Common.formatModifierName(
            market.name,
            null,
            market.specifiers,
            this.state.globals.globals.langCode,
        );

        context.dispatch(
            'selectBetslipOutcome',
            {
                eventId: outright.outrightsOfferId,
                code: outright.code,
                eventDate: outright.utcEndDate,
                eventName: `${outright.name} - ${marketName}`,
                selected: true,
                fix: false,
                type: 'outrights',
                meta:
                {
                    outrightsTypeId: outright.type.outrightsTypeId,
                    marketId: market.outrightsMarketId,
                    outcomeName,
                    outcomeShortName: outcomeName, // TODO
                    marketName,
                    marketShortName: marketName, // TODO
                    coefficient: outcome.value,
                    outcomeTags: (outcome.tags !== undefined && outcome.tags !== null)
                        ? outcome.tags.split(',') : [],
                    specifiers: outcome.specifiers || {},
                    specHash: market.specHash,
                    outcomeId: outcome.outrightsOutcomeId,
                    outcomeHash: outcome.outcomeHash,
                    hasModifier: market.hasModifier ? 1 : 0,
                    modifierValue: market.modifierValue ? market.modifierValue : '',
                    modifierName: market.modifierName
                        ? market.modifierName[this.state.globals.globals.langCode] : '',
                },
                status: outright.status,
                restrictions: outright.restrictions || [],
            },
        );

        if (context.state.subscribedTicketOutrights.indexOf(outright.outrightsOfferId) === -1)
        {
            context.dispatch('subscribeToTicketOutright', outright.outrightsOfferId);
        }
    },
    setSelectedOutrightId(context, outrightId)
    {
        context.commit('setSelectedOutrightId', outrightId);
    },
    subscribeToTicketOutright(context, outrightId)
    {
        if (outrightId != null)
        {
            if (context.state.subscribedTicketOutrights
                && context.state.subscribedTicketOutrights.indexOf(outrightId) === -1)
            {
                context.rootState.offer.offerHandling.subscribeTicket(
                    `${context.rootState.globals.globals.langCode}_outright${outrightId}`,
                    (outright) =>
                    {
                        context.dispatch('updateTicketOutrights', [outright]);
                    },
                );
                context.state.subscribedTicketOutrights.push(outrightId);
            }
        }
    },
    unsubscribeToTicketOutright(context, outrightId)
    {
        context.rootState.offer.offerHandling.unsubscribe(
            `${context.rootState.globals.globals.langCode}_outright${outrightId}`,
            true,
        );
        context.commit('removeSubscribedTicketOutrights', outrightId);
    },
    updateTicketOutrights(context, outrights)
    {
        if (context.rootGetters.betslipType !== 'sport')
        {
            return;
        }
        for (let i = 0; i < outrights.length; i += 1)
        {
            const outright = outrights[i];

            context.dispatch('updateTicketOutright', { outright, skipMessage: (i !== outrights.length - 1) });
        }
    },
    // TODO this may be deprecated
    async updateTicketOutright(context, data)
    {
        if (!context.rootGetters.betslipItems.length)
        {
            return;
        }

        let ticketItemUpdated = false;
        // let outright;

        for (let i = 0; i < context.rootGetters.betslipItems.length; i += 1)
        {
            const item = context.rootGetters.betslipItems[i];

            if (item.type === 'outrights')
            {
                continue;
            }

            if (data.outright.outrightsOfferId === item.matchId)
            {
                for (const market of data.outright.markets)
                {
                    if (market.outcomes.length)
                    {
                        for (const outcome of market.outcomes)
                        {
                            if (outcome.outrightsOutcomeId === item.outcomeId
                                && ((!outcome.outcomeHash) || (item.outcomeHash === outcome.outcomeHash)))
                            {
                                // oldValue
                                item.outcome = {
                                    outcomeId: outcome.outrightsOutcomeId,
                                    outcomeHash: outcome.outcomeHash,
                                    value: Common.formatOdd(outcome.value),
                                    status: outcome.status,
                                };
                                // outright = item;

                                // TODO do this elsewhere
                                /* context.rootState.ticket.ticket.updateItemOdd({
                                    odd: { ...item.outcome },
                                    match: item,
                                    skipMessage: ((data.skipMessage !== undefined) ? data.skipMessage : false),
                                    restrictions: data.outright.restrictions,
                                }); */

                                ticketItemUpdated = true;

                                break;
                            }
                        }
                    }
                    if (ticketItemUpdated)
                    {
                        break;
                    }
                }
            }
        }

        // TODO do this elsewhere
        /* const outrightOut = {
            matchId: outright.outrightsOfferId,
            outcomes: outright.outcomes,
            status: outright.status,
        };

        context.rootState.ticket.ticket.updateSportItemStatus(outrightOut); */
    },
    /* subscribeToOutright(context, outrightId)
    {
        if (outrightId != null)
        {
            if (context.state.subscribedOutrights.indexOf(outrightId) === -1)
            {
                context.rootState.offer.offerHandling.subscribe(
                    `${context.rootState.globals.globals.langCode}_outright${outrightId}`,
                    (outright) =>
                    {
                        changedOutrights.push(outright);
                    },
                );
                context.state.subscribedOutrights.push(parseInt(outrightId, 10));
            }
        }
    }, */
    unsubscribeToOutright(context, outrightId)
    {
        context.rootState.offer.offerHandling.unsubscribe(
            `${context.rootState.globals.globals.langCode}_outright${outrightId}`,
        );
        context.commit('removeSubscribedOutrights');
    },
    unsubscribeToAllOutrightOffer(context)
    {
        context.rootState.offer.offerHandling.unsubscribe(`${context.rootState.globals.globals.langCode}_outright`);

        context.commit('emptySelectedOutrights');
        context.commit('removeSubscribedOutrights');
    },
    async toggleOutrightsTicketUpdates(context)
    {
        const fetchingOutrightsIds = [];
        const outrightsSorted = [];

        if (!context.rootGetters.betslipItems.length)
        {
            return;
        }

        for (let i = 0; i < context.rootGetters.betslipItems.length; i += 1)
        {
            const item = context.rootGetters.betslipItems[i];
            if (item.type === 'outrights')
            {
                fetchingOutrightsIds.push(item.matchId);

                context.dispatch('subscribeToTicketOutright', item.matchId);
            }
        }

        if (fetchingOutrightsIds.length > 0)
        {
            for (const outrightId of fetchingOutrightsIds)
            {
                // eslint-disable-next-line guard-for-in
                for (const id in context.state.outrights)
                {
                    const outright = context.state.outrights[id];
                    if (outright.outrightsOfferId === outrightId)
                    {
                        outrightsSorted.push(outright);
                        break;
                    }
                }
            }

            context.dispatch('updateTicketOutrights', outrightsSorted);
        }
    },
    setOutrightsOfferLoading(context, val)
    {
        context.commit('setOutrightsOfferLoading', val);
    },
    destroyOutrightOffer(context)
    {
        clearInterval(changedOutrightsSettingInterval);

        context.dispatch('unsubscribeToAllOutrightOffer');

        context.rootState.offer.offerHandling.setOfferReloadFunctions({
            name: 'fetchOutrights',
            delete: true,
        });
        context.commit('removeSubscribedOutrights');
        context.commit('clearAllOutrights');
        changedOutrights = [];
    },
    removeOutright(context, outright)
    {
        context.dispatch('unsubscribeToOutright', outright.outrightsOfferId);
        context.commit('removeOutright', outright);
        if (vertical === 'outrights')
        {
            context.dispatch('makeTree');
        }
    },
};

// mutations
const mutations = {
    clearAllOutrights(state)
    {
        state.outrights = {};
        state.outrightTree = null;
        state.allTreeItems = [];
        state.outrightsTreeMapping = null;
        state.selectedOutrightsItems = [];
        state.filteredOutrights = {};
        state.selectedOutrightId = null;
        state.selectedOutrightIds = [];
    },
    emptySelectedOutrights(state)
    {
        state.selectedOutrightId = null;
        state.selectedOutrightIds = [];
    },
    setOutrightsOfferLoading(state, data)
    {
        state.outrightsOfferLoading = data;
    },
    setOutrightError(state, data)
    {
        state.outrightError = data;
    },
    setSelectedOutrightId(state, data)
    {
        state.selectedOutrightId = data;
    },
    setSelectedOutrightIds(state, data)
    {
        state.selectedOutrightIds = data;
    },
    setOutright(state, outright)
    {
        const outrigtInState = state.outrights[outright.outrightsOfferId];

        if (outrigtInState !== undefined)
        {
            if (parseInt(outright.increment, 10) > parseInt(outrigtInState.increment, 10))
            {
                Object.assign(state.outrights[outright.outrightsOfferId], outright);
            }
            else if (parseInt(outright.increment, 10) === parseInt(outrigtInState.increment, 10))
            {
                Object.assign(state.outrights[outright.outrightsOfferId], outright);
            }
        }
        else
        {
            Vue.set(state.outrights, outright.outrightsOfferId, outright);
        }
    },
    setSelectedOutrightsItems(state, data)
    {
        state.selectedOutrightsItems = data;
    },
    setOutrightTree(state, data)
    {
        state.outrightTree = data;
    },
    setFilteredOutrights(state, data)
    {
        state.filteredOutrights = data;
    },
    setConnectedOutrights(state, data)
    {
        state.connectedOutrights = data;
    },
    setAllTreeItems(state, data)
    {
        state.allTreeItems = data;
    },
    setOutrightsTreeMapping(state, data)
    {
        state.outrightsTreeMapping = data;
    },
    removeSubscribedOutrights(state)
    {
        state.subscribedOutrights.splice(0, state.subscribedOutrights.length);
    },
    removeSubscribedTicketOutrights(state, outrightId)
    {
        if (!outrightId)
        {
            state.subscribedTicketOutrights = [];
        }
        state.subscribedTicketOutrights.splice(state.subscribedTicketOutrights.indexOf(outrightId));
    },
    removeOutright(state, outright)
    {
        Vue.delete(state.outrights, outright.outrightsOfferId);
    },
};

export default
{
    state: stateApp,
    getters,
    actions,
    mutations,
};
